export interface IItemBudget {
  description: string;
  amount: string;
  isDiscount?: boolean;
}
